import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const SocialMediaPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  legalContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Social_Media_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Social Media Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy outlines {clientName || "the Company’s"} expectations regarding the responsible use of social media and electronic communications by employees to protect the company’s reputation, ensure compliance with legislation, and maintain a respectful workplace.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and temporary workers who use social media platforms and electronic communication tools in connection with their employment or personal use that could impact the company.
      </p>

      <h4 className="section-title">3. Relevant Legislation</h4>
      <ul>
        <li><strong>Online Safety Bill:</strong> Employees must not post content that is illegal, harmful, or breaches platform rules or UK law.</li>
        <li><strong>Electronic Communications Act 2000:</strong> Covers the regulation of electronic signatures and records.</li>
        <li><strong>Data Protection Act 2018 and GDPR:</strong> Personal data shared on social media must comply with data protection laws.</li>
        <li><strong>Defamation and Harassment Laws:</strong> Employees must avoid content that could defame individuals or harass others.</li>
      </ul>

      <h4 className="section-title">4. Employee Responsibilities</h4>
      <ul>
        <li>Use social media responsibly and professionally during and outside working hours.</li>
        <li>Do not disclose confidential or proprietary company information.</li>
        <li>Avoid posting content that could damage the company’s reputation or relationships.</li>
        <li>Respect colleagues, clients, and competitors; harassment or discriminatory content is strictly prohibited.</li>
        <li>Report any social media or electronic communications incidents that could impact the company.</li>
      </ul>

      <h4 className="section-title">5. Personal vs Professional Use</h4>
      <p className="section-content">
        Employees should clearly distinguish personal opinions from official company communications. Personal social media activity must not imply company endorsement without authorisation.
      </p>

      <h4 className="section-title">6. Monitoring and Enforcement</h4>
      <p className="section-content">
        The company reserves the right to monitor social media use on company devices and networks within legal limits. Breaches of this policy may result in disciplinary action, including dismissal.
      </p>

      <h4 className="section-title">7. Guidance for Official Accounts</h4>
      <ul>
        <li>Only authorised personnel may manage official company social media accounts.</li>
        <li>All posts must adhere to company values, brand guidelines, and legal requirements.</li>
        <li>Regular training will be provided for social media management and compliance.</li>
      </ul>

      <h4 className="section-title">8. Reporting Concerns</h4>
      <p className="section-content">
        Employees should report any concerns related to social media or electronic communications to HR or the Legal department promptly.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Human Resources:</strong> {hrContact || "[Insert Contact Number]"}</li>
        <li><strong>Legal Department:</strong> {legalContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Social Media Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default SocialMediaPolicy;
